export const supportedLocales = {
  en: 'English',
  es: 'Español',
  ja: '日本語',
};
